module.exports = __webpack_public_path__ + "static/media/pdf_icn.e657a1a8.svg";